import { supabase } from '@/integrations/supabase/client';

export type OrdensSyncPreloadContext = {
  nomeToClienteId: Map<string, string>;
  clienteIdToValorHoraLatest: Map<string, number>;
  quiet: boolean;
};

export function resolveClienteCadastroId(
  empresaNome: string | undefined | null,
  ctx: OrdensSyncPreloadContext
): string | null {
  if (!empresaNome) return null;
  const t = empresaNome.trim();
  return ctx.nomeToClienteId.get(t) ?? ctx.nomeToClienteId.get(t.toLowerCase()) ?? null;
}

export function resolveClienteValorHora(
  empresaNome: string | undefined | null,
  ctx: OrdensSyncPreloadContext
): number {
  const clienteId = resolveClienteCadastroId(empresaNome, ctx);
  if (!clienteId) return 0;
  return ctx.clienteIdToValorHoraLatest.get(clienteId) ?? 0;
}

const ID_CHUNK = 30;

export async function loadOrdensSyncPreload(): Promise<OrdensSyncPreloadContext> {
  const nomeToClienteId = new Map<string, string>();

  const { data: clientes, error: errClientes } = await supabase
    .from('clientes_cadastro')
    .select('id, nome');

  if (errClientes) throw errClientes;

  const ids: string[] = [];
  for (const c of clientes || []) {
    if (!c?.nome || !c?.id) continue;
    const t = String(c.nome).trim();
    nomeToClienteId.set(t, c.id);
    nomeToClienteId.set(t.toLowerCase(), c.id);
    ids.push(c.id);
  }

  const clienteIdToValorHoraLatest = new Map<string, number>();
  if (ids.length === 0) {
    return { nomeToClienteId, clienteIdToValorHoraLatest, quiet: true };
  }

  const best = new Map<string, { t: number; v: number }>();

  for (let i = 0; i < ids.length; i += ID_CHUNK) {
    const chunk = ids.slice(i, i + ID_CHUNK);
    const { data: histRows, error: errHist } = await supabase
      .from('clientes_valores_historico')
      .select('cliente_id, valor_hora, data_reajuste')
      .in('cliente_id', chunk);

    if (errHist) throw errHist;

    for (const row of histRows || []) {
      if (!row.cliente_id) continue;
      const ts = new Date(String(row.data_reajuste)).getTime();
      const v = Number(row.valor_hora) || 0;
      const prev = best.get(row.cliente_id);
      if (!prev || ts > prev.t) best.set(row.cliente_id, { t: ts, v });
    }
  }

  for (const [clienteId, { v }] of best) {
    clienteIdToValorHoraLatest.set(clienteId, v);
  }

  return { nomeToClienteId, clienteIdToValorHoraLatest, quiet: true };
}
